<div class="dev-card" *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance else isNotHotel">
   <!-- HEADER -->
   <div class="header">
      <p class="m-0" *ngIf="dev?.state === 'residential'">
         CTC
      </p>
      <p class="m-0" *ngIf="dev?.state === 'fix-rent'">
         Renta fija
      </p>
      <p class="m-0" *ngIf="dev?.state === 'in-construction'">
         Propiedad en remodelación
      </p>
      <p class="m-0" *ngIf="dev?.state !== 'fix-rent' && dev?.state !== 'residential' && !dev?.multiplePerformance && dev?.state !== 'in-construction'">
         Propiedad en operación
      </p>
   </div>

   <!-- DISCOUNT PER PHASE -->
   <div class="d-flex align-items-center p-3 border-bottom" *ngIf="dev?.state === 'in-construction' && dev?.name != 'Casa Roma Norte'">
      <p class="fs-12 m-0 text-dark fw-bold">Descuento inmediato por preventa: </p>
      <p class="fs-12 m-0 ms-1 text-dark fw-bold">{{ devParts.discount * 100 }}%</p>
   </div>
   <!-- END | DISCOUNT-->

   <!-- PERFORMANCE -->
   <div class="performance">
      <div class="d-flex" *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance else isNotHotel">
         <img src="" alt="" />
         <p>Rendimiento anual fijo:</p>
         <p class="ms-auto fw-sbold">
            {{ toFixed(dev.performance + (dev.appreciation || 0) + dev?.linePremier) }}%
         </p>
      </div>
      <ng-template #isNotHotel>
         <div class="d-flex" *ngIf="dev?.state === 'residential' else isNotHotel">
            <img src="" alt="" />
            <p >TIR anual estimada: </p>
            <p class="ms-auto fw-sbold">
               {{ dev?.intervalPerformance }}
            </p>
         </div>
      </ng-template>

      <div class="d-flex" *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance else noIsHotel">
         <img src="" alt="" />
         <p>Liquidez anual estimada:</p>
         <p class="ms-auto fw-sbold">{{ dev.performance }}%</p>
      </div>
      <ng-template #noIsHotel>
         <div class="d-flex">
            <img src="" alt="" />
            <p>Plazo:</p>
            <p class="ms-auto fw-sbold">{{dev?.intervalMonthsResidential}}</p>
         </div>
      </ng-template>

      <div class="d-flex" *ngIf="dev?.name !== 'Grand Sánchez Azcona' else isNotPlusvalia">
         <img src="" alt="" />
         <p *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance">Plusvalía anual estimada</p>
         <p *ngIf="dev?.state === 'residential'">Regalía fija</p>
         <p class="ms-auto fw-sbold">{{ dev.appreciation || 0 }}%</p>
      </div>

      <ng-template #isNotPlusvalia>
         <div class="d-flex">
            <img src="" alt="" />
            <p>Línea Platinum</p>
            <p class="ms-auto fw-sbold">{{ dev.appreciation || 0 }}%</p>
         </div>
      </ng-template>

      <div class="d-flex" *ngIf="dev?.linePremier">
         <img src="" alt="" />
         <p>Linea anual premier</p>
         <p class="ms-auto fw-sbold">{{ dev?.linePremier || 0 }}%</p>
      </div>

   </div>
   <!-- END | PERFORMANCE -->

   <!-- BODY -->
   <div class="body">
      <div class="text-center fw-sbold">
         <div [innerHTML]="labelFreeParts"></div>
      </div>

      <div class="card-achoraded mt-2">
         <div class="progress-container">
           <div class="bg-line">
             <div class="bg-process" [style.width.%]="percentage">
               <div class="message fw-sbold text-center" [style.right.px]="rightPosition()"><span [style.transform]="getSpanTranslate()"></span>{{ message }}</div>
             </div>
           </div>
         </div>
       </div>

     <div class="card-goal mt-3">
      <div class="first d-flex justify-content-between">
         <p class="cl-primary fw-sbold">Monto fondeado: </p>
         <p class="cl-primary fw-sbold">{{ ( devParts?.funded * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
      </div>
      <div class="second mt-2" *ngIf="percentage !== 100">
         <p class="cl-primary fw-sbold">Monto a lograr: </p>
         <div class="mt-1 ps-2 d-flex justify-content-between">
            <div class="amount-dot min"></div>
            <p>Mínimo</p>
            <p class="ms-auto fw-sbold">{{ ( devParts?.minAmountProject * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
         </div>
         <div class="ps-2 d-flex justify-content-between">
            <div class="amount-dot max"></div>
            <p>Máximo</p>
            <p class="ms-auto fw-sbold">{{ ( devParts?.total * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
         </div>
      </div>
     </div>

      <!-- <div class="d-flex justify-content-between info">
         <p>Fondeado:</p>
         <p *ngIf="dev?.name != 'Casa Roma Norte' else noIsRoma">
            ${{ devParts.active * devParts.value | number }} de ${{
               devParts.total * devParts.value | number
            }}
         </p>
         <ng-template #noIsRoma>
            <p>
               $ {{ sumAllPhases.active * 1000 | number }} de $ {{
                  sumAllPhases.total * 1000 | number
               }}
            </p>
         </ng-template>
      </div> -->
      <div class="d-flex mt-3 justify-content-between info">
         <p>Reparto:</p>
         <p>{{ dev.capitalization }}</p>
      </div>

      <div class="d-flex justify-content-between info">
         <p>Plazo:</p>
         <p *ngIf="dev?.intervalMonthsResidential else noHavePlazo">
            {{ dev?.intervalMonthsResidential }}
         </p>
         <ng-template #noHavePlazo>
            <p>Indefinido</p>
         </ng-template>
      </div>

      <div class="d-flex justify-content-between info" *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance && dev?.state == 'in-construction'">
         <p>Fecha de próximo reparto:</p>
         <p>{{ dev.nextDist | date : 'dd/MM/yy' }}</p>
      </div>

      <div class="d-flex justify-content-between info">
         <p>Costo por participación:</p>
         <p>{{ devParts.value | currency :'MXN':'symbol':'1.0-0' }}</p>
      </div>
      <div class="d-flex justify-content-between info" *ngIf="!devParts.minAmountProject">
         <p>Participaciones disponibles:</p>
         <p>{{ devParts.free | number }}</p>
      </div>
      <div class="evaluation-container d-flex pb-0">
         <div class="row">
             <div class="col-12 ps-1">
                 <div class="d-flex align-items-center h-100">
                  <p class="fw-sbold fs-11">
                     Evaluación de riesgos
                     <i
                        class="mnf-explain-border cr-pointer fs-9 my-auto"
                        (click)="openLink('https://centrodeayuda.monific.com/qu%C3%A9-es-la-evaluaci%C3%B3n-monific')"
                     ></i>
                  </p>
                 </div>
             </div>
         </div>
         <div class="letter-container ms-5">
           <div class="letter" [ngClass]="getLetterClass()">{{ letraEjemplo }}</div>
           <div class="lines">
             <div class="new-line rb-back"></div>
             <div class="new-line mb-back"></div>
             <div class="new-line rm-back"></div>
             <div class="new-line ra-back"></div>
           </div>
         </div>
     </div>
      <!-- END | BODY -->

      <hr />

      <!-- PROJECT PHASES -->
      <div *ngIf="this.dev.phases.length > 1 && this.dev?.name != 'Casa Roma Norte'">
         <div class="phases" (click)="phasesView = !phasesView">
            <p class="fw-sbold fs-11">Etapas</p>
            <i class="mnf-arrow arrow" [ngClass]="{ rotate: phasesView }"></i>
         </div>

         <div class="container-phases fs-12" [ngClass]="{ show: phasesView }">
            <div>
               <span>Etapa</span>
               <span class="d-flex cr-default">
                  <span (click)="forwardPhase()">◀</span>
                  <p class="mx-2 mb-0">{{ indexPhase }}/{{ maxPhase }}</p>
                  <span (click)="nextPhase()">▶</span>
               </span>
            </div>
            <div>
               <span>Fondeado</span>
               <span
                  >${{ selectedPhase.active * 1000 | number }} de ${{
                     selectedPhase.total * 1000 | number
                  }}</span
               >
            </div>
            <div *ngIf="estimatedFundedTime">
               <span>Tiempo estimado de fondeo</span>
               <span></span>
            </div>
         </div>
      </div>

      <!-- DESCUENTO DIRECTO -->
      <div *ngIf="devParts.discount && dev.name != 'Casa Roma Norte'" class="d-flex justify-content-between mb-3">
         <p class="fw-sbold fs-11">Descuento directo <i
            class="mnf-explain-border fs-9 my-auto"
            matTooltip="Al invertir durante el periodo de remodelación o construcción, el solicitante otorgará un descuento
            inmediato por preventa."
         ></i></p>
         <p class="fw-sbold fs-11">{{ selectedPhase.discount | percent: '0.0-0'}}</p>
      </div>

      <!-- FOOTER -->
      <!-- <div class="w-100 mb-1">
      <a routerLink="./invertir">
        <button mat-button class="invert flat w-100 mb-2">Calcular rendimiento</button>
      </a>
    </div> -->
      <div class="w-100 mb-1" *ngIf="userHaveParts && dev.resale">
         <a [routerLink]="[resaleUserPartPath, dev.pid]">
            <button mat-button class="invert regular w-100 mb-2">
               Vender mis participaciones
            </button>
         </a>
      </div>
      <div class="w-100" *ngIf="devParts.free && devParts.free > 0">
         <p class="fw-bold text-center fs-13 cl-black my-4">{{ textDateToInvest }}</p>
         <a routerLink="./invertir" *ngIf="devParts.free">
            <button mat-button class="invest regular w-100 bg-primary-important">
               Quiero invertir
            </button>
         </a>
      </div>
      <div class="w-100">
         <a [routerLink]="[resaleBuyUserPartPath, dev.pid]" *ngIf="dev.resale">
            <button
               mat-button
               class="invest regular w-100 my-2 bg-pink-important"
            >
               Ir al mercado secundario
            </button>
         </a>
      </div>
      <!-- END | FOOTER -->

      <p class="text-center fs-12 mt-4 cl-primary-4 fw-bold">{{allUsersParts | number}} {{allUsersParts > 1 ?  'inversionistas en el' : 'inversionista en el'}} proyecto</p>

   </div>
</div>

<ng-template #isNotHotel>
   <div class="dev-card pb-2">

      <!-- HEADER CARD -->
      <div class="header">
         <p class="m-0" *ngIf="dev?.state === 'residential' && dev?.pid !== 'the-quarters'">
            CTC
         </p>
         <p class="m-0" *ngIf="dev?.state === 'residential' && dev?.pid == 'the-quarters'">
            Propiedad en operación
         </p>
         <p class="m-0" *ngIf="dev?.state == 'fix-rent' && dev?.pid == 'the-quarters'">
            Propiedad en operación
         </p>
      </div>

      <!-- PEFORMANCE ESTIMATE -->
      <div class="mt-4">
         <p class="fw-bold text-center fs-14">Rendimiento anual estimado</p>
         <div class="row px-3 mx-0">
            <div class="d-flex align-items-center justify-content-evenly bg-residential-pf col-12 m-auto p-2">
               <div class="text-center" *ngFor="let item of showPerformance">
                  <p class="m-0 cl-primary fw-bold">{{ item.percent }} %</p>
                  <p class="m-0 cl-black">{{ item.info }}</p>
               </div>
               <div class="text-center" *ngFor="let item of showPerformanceWithoutCTC">
                  <p class="m-0 cl-primary fw-bold">{{ item.percent }} %</p>
                  <p class="m-0 cl-black">{{ item.info }}</p>
               </div>
            </div>
         </div>
      </div>

      <div class="body mb-3">
         <div class="text-center mb-3 fw-sbold">
            <div [innerHTML]="labelFreeParts" class="mt-3"></div>
         </div>

         <!--
         <div class="d-flex justify-content-between fw-sbold cl-primary-4">
            <p>% Fondeo total</p>
            <p>{{ percentage | number : '2.1-2' }}%</p>
         </div>
      -->

      <div class="card-achoraded mt-2">
         <div class="progress-container">
           <div class="bg-line">
             <div class="bg-process" [style.width.%]="percentage">
               <div class="message fw-sbold text-center" [style.right.px]="rightPosition()"><span [style.transform]="getSpanTranslate()"></span>{{ message }}</div>
             </div>
           </div>
         </div>
       </div>

        <div class="card-goal mt-3">
         <div class="first d-flex justify-content-between">
            <p class="cl-primary fw-sbold">Monto fondeado: </p>
            <p class="cl-primary fw-sbold">{{ ( devParts?.funded * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
         </div>
         <div class="second mt-2" *ngIf="percentage !== 100">
            <p class="cl-primary fw-sbold">Monto a lograr: </p>
            <div class="mt-1 ps-2 d-flex justify-content-between">
               <div class="amount-dot min"></div>
               <p>Mínimo</p>
               <p class="ms-auto fw-sbold">{{ ( devParts?.minAmountProject * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
            </div>
            <div class="ps-2 d-flex justify-content-between">
               <div class="amount-dot max"></div>
               <p>Máximo</p>
               <p class="ms-auto fw-sbold">{{ ( devParts?.total * 1000 ) | currency:'MXN':'symbol':'1.0-0' }}</p>
            </div>
         </div>
        </div>

         <!-- FONDEADO ESTIMADO -->
         <!-- <div class="d-flex justify-content-between info">
            <p>Fondeado:</p>
            <p>
               ${{ devParts.active * devParts.value | number }} de ${{devParts.total * devParts.value | number}}
            </p>
         </div> -->

         <!-- PLAZO ESTIMADO -->
         <div class="mt-3 d-flex justify-content-between info">
            <p>Plazo:</p>
            <p>{{dev?.intervalMonthsResidential}}</p>
         </div>

         <div class="d-flex justify-content-between info" *ngIf="dev?.nextDist?.includes('-')">
            <p>Fecha de próximo reparto:</p>
            <p>{{ dev.nextDist | date : 'dd/MM/yy' }}</p>
         </div>

         <div class="d-flex justify-content-between info" *ngIf="dev?.state !== 'residential' && !dev?.multiplePerformance && dev?.state == 'in-construction'">
            <p>Fecha de próximo reparto:</p>
            <p>{{ dev.nextDist | date : 'dd/MM/yy' }}</p>
         </div>

         <div class="d-flex justify-content-between info">
            <p>Costo por participación:</p>
            <p>{{ devParts.value | currency :'MXN':'symbol':'1.0-0'}}</p>
         </div>
         <div class="d-flex justify-content-between info" *ngIf="!devParts.minAmountProject">
            <p>Participaciones disponibles:</p>
            <p>{{ devParts.free | number }}</p>
         </div>
         <div class="evaluation-container d-flex pb-0">
            <div class="row">
                <div class="col-12 ps-1">
                    <div class="d-flex align-items-center h-100">
                     <p class="fw-sbold fs-11">
                        Evaluación de riesgos
                        <i
                           class="mnf-explain-border cr-pointer fs-9 my-auto"
                           (click)="openLink('https://centrodeayuda.monific.com/qu%C3%A9-es-la-evaluaci%C3%B3n-monific')"
                        ></i>
                     </p>
                    </div>
                </div>
            </div>
            <div class="letter-container ms-5">
               <!-- La siguiente variable solo es de ejemplo, sustituir por la real de la evaluación cuando este disponible -->
              <div class="letter" [ngClass]="getLetterClass()">{{ letraEjemplo }}</div>
              <div class="lines">
                <div class="new-line rb-back"></div>
                <div class="new-line mb-back"></div>
                <div class="new-line rm-back"></div>
                <div class="new-line ra-back"></div>
              </div>
            </div>
        </div>
      </div>
         <!-- END | BODY -->

      <!-- BUTTON PURCHASE PART -->
      <div class="w-100" *ngIf="devParts.free && devParts.free > 0">
         <p class="fw-bold text-center fs-13 cl-black">{{ textDateToInvest }} </p>
         <a routerLink="./invertir" *ngIf="devParts.free">
            <button mat-button class="invest regular w-100 bg-primary-important">
               Quiero invertir
            </button>
         </a>
      </div>

      <p class="text-center fs-12 mt-4 cl-primary-4 fw-bold">{{allUsersParts}} {{allUsersParts > 1 ?  'inversionistas en el' : 'inversionista en el'}}  proyecto</p>

   </div>

</ng-template>
